export const generalPhases = [
  'Business News',
  'Financial News',
  'Economic News',
  'News and Updates',
  'News and Tweets',
  'News and Research',
  'Tweets and Business News',
  'Tweets and Financial News',
  'Tweets and Economic News',
  'Financial and Business News',
  'Updates and Financial News',
  'Updates and Business News',
  'Updates and Economic News',
  'Research and Business News',
  'Research and Financial News',
  'Research and Economic News',
  'Top Business News',
  'Top Financial News',
  'Top Economic News',
  'Top News and Updates',
  'Top News and Tweets',
  'Top News and Research',
  'Top Tweets and Business News',
  'Top Tweets and Financial News',
  'Top Tweets and Economic News',
  'Top Financial and Business News',
  'Top Updates and Financial News',
  'Top Updates and Business News',
  'Top Updates and Economic News',
  'Top Research and Business News',
  'Top Research and Financial News',
  'Top Research and Economic News',
];

export default generalPhases;
